export default __webpack_public_path__ + "static/media/telecom2.b53a2ae7.jpg";